import React, { Component } from 'react'

export default class SinPermisosView extends Component {
  static propTypes = {}

  render() {
    return (
      <div className="common-sin-permisos-view">
        <i className="material-icons icon">lock</i>
        <div className="fade-in-400 text">No tienes permisos para ver esta página.</div>
      </div>
    )
  }
}
